import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '@panel/commons';
import { useSelector } from 'react-redux';
import { Container, Wrapper, ModuleContainer, Aside, DisabledOverlay } from './styles';
import { SectionsWrapper } from './sections';
import { FeedbackBox } from '../feedbackbox';
import { SavePostingSelectors } from '../../ducks/savePosting';

function Step3Container() {
  const { savedFromModal } = useSelector(SavePostingSelectors.getSavePostingState);
  const [reachedBreakPoint] = useBreakpoint(1280);
  const { t } = useTranslation();
  return (
    <Container data-repa='step3-container' savedFromModal={savedFromModal}>
      {savedFromModal && <DisabledOverlay />}
      <Wrapper>
        {reachedBreakPoint && (
          <Aside data-repa='step3-aside'>
            <FeedbackBox />
          </Aside>
        )}
        <ModuleContainer data-repa='step3-moduleCotainer'>
          <SectionsWrapper back='multimedia' title={t('publisher.step3.mainTitle')} eventName='Extras' />
        </ModuleContainer>
      </Wrapper>
    </Container>
  );
}

export default Step3Container;
